export default {
	data() {
		return {
			bid: {
				name: "",
				is_finalized: 0,
				applied_sales_tax_json: ""
			},
			componentDescendantIds: [],
			partsFields: [
				{label: "Part Description",key:"description"},
				{label: "Part #",key:"part_number"},
				{label: "Qty",key:"qty",align:"right"},
				{label: "Price", key: 'price',align: 'right'},
				{label: "",key:'material_unit_type'},
				{label: "Price Adj.", key: 'priceAdjustmentFormatted', align: 'right'},
				{label: "Markup",key: 'markupFormatted',align: 'right'},
				{label: 'Labour Hrs',key: 'labour_hrs',align:'right'},
				{label: 'Total', key: 'totalFormatted', align: 'right'}
			],
			equipmentFields: [
				{label: 'Equipment Type',key:'typeName'},
				{label: 'Object Id',key:'object_id'},
				{label: 'Qty',key:'qtyWithUnit',align:'right'},
				{label: "Rate", key: "rate",align:'right'},
				{label: "Price Adj.", key: 'priceAdjustmentFormatted', align: 'right'},
				{label: "Markup",key: 'markupFormatted',align: 'right'},
				{label: 'Total', key: 'totalFormatted', align: 'right'}
			],
			labourFields: [
				{label: 'Classification',key:'classificationTitleWithType'},
				{label: "Crew", key: "crew",align:'right'},
				{label: 'Hrs',key:'hrsFormatted',align:'right'},
				{label: 'Rate',key:'rate',align:'right'},
				{label: "Price Adj.", key: 'priceAdjustmentFormatted', align: 'right'},
				{label: "Markup",key: 'markupFormatted',align: 'right'},
				{label: "Hrly Selling Rate",key:'sellingRate',align: 'right'},
				{label: 'Total', key: 'totalFormatted', align: 'right'}
			],
			additionalFactorFields: [
				{label: 'Description',key:'description'},
				{label: 'Variable',key:'variableFormatted'},
				{label: 'Factors',key:'operandsAppended'},
				{label: 'Total',key:'totalFormatted',align: "right"},
			],
			quotesFields: [
				{label: 'Supplier',key:'supplierName'},
				{label: 'Description',key:'description'},
				{label: 'Price',key:'rate',align: 'right'},
				{label: 'Qty',key:'qtyFormatted',align: 'right'},
				{label: "Price Adj.", key: 'priceAdjustmentFormatted', align: 'right'},
				{label: "Markup",key: 'markupFormatted',align: 'right'},
				{label: 'Total',key:'totalFormatted',align: 'right'}
			],
			variableOptions: [
				{text: 'Labour Hrs',value: 'labour-hrs'},
				{text: 'Labour Value',value: 'labour-value'},
				{text: 'Material Value',value: 'material-value'},
				{text: 'Equipment Value',value: 'equipment-value'},
				{text: 'Flat Rate',value: 'flat-rate'}
			],
			additionalFactorVariableScopeOptions: [
				{text: 'Direct Component Only',value: 'direct-component'},
				{text: 'Whole Component (direct & descendant components)',value: 'full-component'},
				{text: 'Whole Bid',value: 'full-bid'},				
			],
			recordTypeMap: {
				materials: 'Material',
				equipment: 'Equipment',
				labour: 'EmployeeClassification',
				'supplier-quotes' : 'SupplierQuote',
				'additional-factors' : 'AdditionalFactor'
			}
		}
	},
	computed: {
		bidComponentsNested() {
			return this.renderNestedBid()
		}
	},
	methods: {
		flattenRecordsFromNested() {
			let flattenedRecords = [], vm = this
			this.bidComponentsNested.forEach(mainComp => {

				flattenedRecords = [
					...flattenedRecords,
					...vm.getTotalElementsOnComponent(mainComp)
				]
			})

			return flattenedRecords
		},
		elementInListIndex(elementList,element,requireMatchingPricing) {
			//match the element to the elements currently in the list.

			return elementList.filter(listElement => listElement.type == element.type).findIndex(listElement => {
				
				let match = false

				let objectIdKey = "object_id"
				
				if (objectIdKey in listElement && objectIdKey in element && +listElement[objectIdKey] == +element[objectIdKey] && +listElement[objectIdKey] > 0) {
					match = true
				}

				if ("unit" in listElement && "unit" in element && listElement.unit != element.unit)
					//they don't all match, this is not a match with requiredMatchingPricing
					match = false

				//if (element.typeName == "Hydro Vac Truck")
				//	console.log(listElement,element)

				/*
				else {

					let listElementParsed = {}
					try {
						listElementParsed = JSON.parse(listElement.field_values_json)
					}
					catch (e) {}

					let elementParsed = {}
					try {
						elementParsed = JSON.parse(element.field_values_json)
					}
					catch (e) {}

					let parsedComparisonFields = ["classification_id","typeName","part_number","rate","description"]

					let matched = false
					parsedComparisonFields.forEach(field => {
						//console.log(field, elementParsed)
						if (field in elementParsed && field in listElementParsed) {

							if (elementParsed[field] == listElementParsed[field] && elementParsed[field]) 
								matched = true
						}
					})

					//console.log(matched)

					match = matched
				}
				*/

				if (!match)
					return false

				if (requireMatchingPricing) {
					// Only match if all pricing/markup/adjustment is the same
					let requiredMatchingFields = ["rate","price_adjustment","markup"]

					requiredMatchingFields.forEach(field => {

						if (field in listElement && field in element && +listElement[field] != +element[field])
							//they don't all match, this is not a match with requiredMatchingPricing
							match = false
					})

				}

				return match
			})
		},
		flattenedRecordsFromNested(selectedElement) {
			let vm = this

			let mutated = this.flattenRecordsFromNested()
				.filter(el => el.type == this.recordTypeMap[selectedElement])
				.map(el => {

					el.objectRecordId = el.id

					let priceAdjustment = +el.price_adjustment
					el.priceAdjustmentFormatted = priceAdjustment.toFixed(3)

					let markup = +el.markup
					el.markupFormatted = markup.toFixed(3)

					let parsedFieldsToUse = []

					if (selectedElement == 'labour') {
						parsedFieldsToUse = ["classificationTitle"]

						let hrs = +el.qty
						el.hrs = hrs
						el.hrsFormatted = hrs.toFixed(2)
						el.sellingRate = +el.rate * +el.markup * +el.price_adjustment
						el.sellingRate = el.sellingRate.toCurrency()

						el.classificationTitleWithType = vm.buildClassificationTitleWithType(el)

						el.object_id = el.parsedFields.classification_id
					}
					else if (selectedElement == 'materials') {
						parsedFieldsToUse = ["description","part_number"]

						let labour_hrs = +el.parsedFields.labour_hrs

						el.labour_hrs = labour_hrs.toFixed(2)

						if (!("rate" in el) || +el.rate == 0) {
							el.rate = 0;
							if ("rate" in el.parsedFields && +el.parsedFields.rate != 0)
								el.rate = +el.parsedFields.rate
							else if ("material_price" in el.parsedFields)
								el.rate = +el.parsedFields.material_price / +el.parsedFields.per
							else if ("price" in el.parsedFields)
								el.rate = +el.parsedFields.price / +el.parsedFields.per
						}

						el.qty = +el.qty
						el.qty = el.qty.toFixed(2)

						el.price = el.rate.toCurrency()

						el.object_id = el.parsedFields.material_id
					}
					else if (selectedElement == 'equipment') {
						parsedFieldsToUse = ["typeName"]

						el.object_id = el.parsedFields.equipment_type_id

						let unit = "hour"
						if ("unit" in el && el.unit) 
							unit = el.unit

						let qty = +el.qty
						el.qtyWithUnit = qty.toFixed(2) + " " + unit + "s"

					}
					else if (selectedElement == 'supplier-quotes') {
						parsedFieldsToUse = ['supplierName']

						el.object_id = false
					}
					else if (selectedElement == 'additional-factors') {
						parsedFieldsToUse = ["description"]

						el.object_id = false
					}

					parsedFieldsToUse.forEach(field => {
						el[field] = el.parsedFields[field]
					})

					if (selectedElement == 'additional-factors') {
						let component = el.JobBidComponent

						let objectRecordId = el.objectRecordId

						el = vm.mutateAdditionalFactor(el.parsedFields,el.bid_component_id)
						el.JobBidComponent = component

						el.objectRecordId = objectRecordId

						if (component.is_reverse_calculated == 0) {
							el.runningProduct = +component.qty * el.runningProduct
							el.totalRaw = el.runningProduct
						}
					}
					else {
						el.totalBaseRaw = el.qty * +el.rate

						el.totalRaw = el.totalBaseRaw * +el.price_adjustment * +el.markup
					}

					el.sourceComponentName = ""
					if ("JobBidComponent" in el && el.JobBidComponent)
						el.sourceComponentName = el.JobBidComponent.item_number + ". " + el.JobBidComponent.name

					
					el.totalFormatted = el.totalRaw.toCurrency()

					return el
				})

			//return mutated
			let consolidated = []

			mutated.forEach(el => {

				let index = vm.elementInListIndex(consolidated,el,true)

				if (index >= 0) {

					consolidated[index].sourceRecords.push(vm.cloneObj(el))

					let qty = +consolidated[index].qty
					consolidated[index].qty = qty + +el.qty

					consolidated[index].qtyWithUnit = qty.toFixed(2)

					if (selectedElement == 'equipment') {
						let unit = "hour"
						if ("unit" in consolidated[index] && consolidated[index].unit) 
							unit = consolidated[index].unit

						let qty = +consolidated[index].qty
						consolidated[index].qtyWithUnit = qty.toFixed(2) + " " + unit + "s"
					}

					if (consolidated[index].description != el.description)
						consolidated[index].description += ", " + el.description

					consolidated[index].totalBaseRaw = consolidated[index].qty * +consolidated[index].rate
					consolidated[index].totalRaw  = consolidated[index].totalBaseRaw * +consolidated[index].price_adjustment * +consolidated[index].markup
					consolidated[index].totalFormatted = consolidated[index].totalRaw.toCurrency()

					
					if (selectedElement == 'labour') {
						consolidated[index].hrs = consolidated[index].qty
						consolidated[index].hrsFormatted = consolidated[index].hrs.toFixed(2)
					}
					if (selectedElement == 'materials') {
						consolidated[index].qty = consolidated[index].qty.toFixed(2)
					}

					consolidated[index].isCompositeLineItem = true

				}
				else {
					consolidated.push(el)

					consolidated[consolidated.length - 1].sourceRecords = [vm.cloneObj(el)]
				}
			})

			return consolidated
		},
		addComponentPricing(comp) {
			let vm = this
			let qty = 1
			if ("qty" in comp && comp.qty) {
				qty = +comp.qty
				qty = qty.round(2)
			}

			if (comp.is_reverse_calculated == 0) {
				comp.unitPriceRaw = vm.getFullComponentValue(comp)
				comp.totalPriceRaw = comp.unitPriceRaw.round(2) * qty
			}
			else {
				comp.totalPriceRaw = vm.getFullComponentValue(comp)
				comp.unitPriceRaw = comp.totalPriceRaw.round(2) / qty
			}

			return comp
		},
		renderNestedBid() {
			let vm = this
			let nestedComponents = []
			let flatComponents = this.cloneObj(this.$store.bidComponentsFlat)

			/*
			flatComponents = flatComponents.map(comp => {
				//comp.directValueRaw = vm.calcComponentTotal(comp)

				comp.directValueRaw = +comp.direct_value

				return comp
			})
			*/

			let cnt = 0

			//keep building out the list until there's no more flat components to place somewhere, but bail out at 10,000 iterations as a fail-safe
			while (flatComponents.length > 0 && cnt < 10000) {
				cnt++

				let spliceIndex = false

				flatComponents.forEach((comp,index) => {

					if (spliceIndex === false) {
						if (comp.bid_component_id == 0) {
							nestedComponents.push(comp)
							flatComponents.splice(index,1)
						}
						else {
							let parentComp = vm.searchNestedComponents(nestedComponents,comp.bid_component_id)

							if (parentComp) {

								spliceIndex = index

								comp.directValueRaw = +comp.direct_value

								if ("JobBidComponent" in parentComp && parentComp.JobBidComponent) 
									parentComp.JobBidComponent.push(vm.cloneObj(comp))
								else
									parentComp.JobBidComponent = [vm.cloneObj(comp)]

								parentComp.JobBidComponent = parentComp.JobBidComponent.sort((a,b) => {
									if (+a.id < +b.id)
										return -1
									else
										return 1
								})

								parentComp.JobBidComponent = parentComp.JobBidComponent.sort((a,b) => {
									if (+a.order_index < +b.order_index)
										return -1
									else
										return 1
								})
							}
						}
					}
				})

				if (spliceIndex !== false)
					flatComponents.splice(spliceIndex,1)
			}

			//iterate top level components and calc unit price
			let nestedComponentsWithPricing = nestedComponents.map(comp => {
				
				if ("JobBidComponent" in comp && comp.JobBidComponent) {
					comp.JobBidComponent = comp.JobBidComponent.map(subComp => {

						subComp = vm.addComponentPricing(subComp)

						if ("JobBidComponent" in subComp && subComp.JobBidComponent) {
							subComp.JobBidComponent = subComp.JobBidComponent.map(subSubComp => {
								return  vm.addComponentPricing(subSubComp)
							})
						}

						return subComp
					})
				}

				return vm.addComponentPricing(comp)
			})

			nestedComponentsWithPricing = nestedComponentsWithPricing.sort((a,b) => {
				if (+a.order_index < +b.order_index)
					return -1
				else
					return 1
			})

			return nestedComponentsWithPricing
		},
		qtyChange(qty,componentId) {
			let vm = this

			let id = componentId

			this.postData("JobBidComponent/save",{id,qty},true).then(response => {
				if (response.success) {
					vm.alertSaved("Qty updated")
				}
			})
		},
		totalRecordsValue(records) {
			return records.reduce((acc,item) => {
				let recordRounded = +item.totalRaw

				recordRounded = recordRounded.round(2)

				return acc + recordRounded
			},0)
		},
		buildClassificationTitleWithType(classification) {
			let hoursTypeLabel = " (reg)"
			let classificationTitle = ""

			let hoursType = ""
			if ("hours_type" in classification) 
				hoursType = classification.hours_type
			else if ("parsedFields" in classification && classification.parsedFields && "hours_type" in classification.parsedFields)
				hoursType = classification.parsedFields.hours_type

			if (hoursType != 1 && hoursType != "")
				hoursTypeLabel = " ("+hoursType+"x)"

			if ("classificationTitle" in classification)
				classificationTitle = classification.classificationTitle
			else if ("parsedFields" in classification && classification.parsedFields && "classificationTitle" in classification.parsedFields)
				classificationTitle = classification.parsedFields.classificationTitle

			return classificationTitle + hoursTypeLabel
		},
		getChildrenComponentIds(sourceList,parentId,idList = []) {
			let vm = this
			let directChildren = sourceList.filter(comp => comp.bid_component_id == parentId)

			directChildren.forEach(comp => {
				idList.push(comp.id)

				idList = [
					...idList,
					vm.getChildrenComponentIds(sourceList,comp.id)
				]
			})

			return idList
		},
		//searches a nested list of components recursively for an id, and returns the matching component object
		searchNestedComponents(nestedComponentList,idToSearchFor) {
			let vm = this

			let match = false

			nestedComponentList.forEach(comp => {
				if (!match) {
					if (comp.id == idToSearchFor) 
						match = comp
					else if ("JobBidComponent" in comp && comp.JobBidComponent) 
						match = vm.searchNestedComponents(comp.JobBidComponent,idToSearchFor)	
				}
			})

			return match
		},
		getTotalElementsOnComponent(comp,elementType) {
			let elements = [], vm = this

			let childElements = []
			if ("JobBidComponentObject" in comp && comp.JobBidComponentObject) {
				comp.JobBidComponentObject.filter(el => el.type == elementType || !elementType).forEach(el => {
					let mutatedEl = vm.cloneObj(el)

					let parsedFields = {}
					try {
						parsedFields = JSON.parse(el.field_values_json)
					}
					catch (e) {}

					mutatedEl.parsedFields = parsedFields

					//only multiply by component qty if calculation method is component price = unit price
					if (comp.is_reverse_calculated == 0)
						mutatedEl.qty = +mutatedEl.qty * +comp.qty
					else
						mutatedEl.qty = +mutatedEl.qty

					mutatedEl.JobBidComponent = comp

					elements.push(mutatedEl)
				})
			}
			if ("JobBidComponent" in comp && comp.JobBidComponent) {
				comp.JobBidComponent.forEach(childComp => {
					let descendantElements = vm.getTotalElementsOnComponent(childComp,elementType)

					descendantElements.forEach(descEl => {
						elements.push(vm.cloneObj(descEl))
					})
				})
			}

			return elements
		},
		getFullComponentValue(comp) {
			let total = 0, vm = this

			if ("JobBidComponent" in comp && comp.JobBidComponent) {
				comp.JobBidComponent.forEach(childComp => {
					
					let qty = 1
					if ("qty" in childComp && childComp.qty) {
						qty = +childComp.qty
						qty = qty.round(2)
					}

					if (childComp.is_reverse_calculated == 0)
						total += vm.getFullComponentValue(childComp) * qty
					else
						total += vm.getFullComponentValue(childComp)
				})

				return total + +comp.direct_value
			}
			else {
				return +comp.direct_value
			}
		},
		getAdditionalFactorVariableValue(variable,scope,bidObjects,componentId) {

			let value = 0, filteredObjects = [], vm = this

			if (scope == 'direct-component') 
				filteredObjects = bidObjects.filter(obj => obj.bid_component_id == componentId)
			
			else if (scope == 'full-component') {
				let componentIds = [
					...this.componentDescendantIds,
					componentId
				]

				filteredObjects = bidObjects.filter(obj => componentIds.find(id => id == obj.bid_component_id))
			}
			else if (scope == 'full-bid')
				filteredObjects = bidObjects
			else
				return 0
			
			if (variable == 'labour-hrs') {
				return filteredObjects
					.filter(obj => obj.type == 'EmployeeClassification')
					.reduce((acc,obj) => acc + +obj.qty,0)
			}
			else if (variable == 'labour-value') {
				return filteredObjects
					.filter(obj => obj.type == 'EmployeeClassification')
					.reduce((acc,obj) => acc + vm.calcObjectValue(obj),0)
			}
			else if (variable == 'material-value') {
				return filteredObjects
					.map(obj => {
						if (!("rate" in obj) || !obj.rate) {
							//we need to figure out the rate from the field_values_json
							let parsedFields = {}
							try {
								parsedFields = JSON.parse(obj.field_values_json)
							}
							catch (e) {}

							if ("material_price" in parsedFields)
								obj.rate = +parsedFields.material_price / +parsedFields.per
							else if ("price" in parsedFields) //for manually added materials
								obj.rate = +parsedFields.price / +parsedFields.per
						}

						return obj
					})
					.filter(obj => obj.type == 'Material')
					.reduce((acc,obj) => acc + vm.calcObjectValue(obj),0)

			}
			else if (variable == 'equipment-value') {
				return filteredObjects
					.filter(obj => obj.type == 'Equipment')
					.reduce((acc,obj) => acc + vm.calcObjectValue(obj),0)
			}

			return 0
		},
		mutateAdditionalFactor(factor,componentId) {
			let operandsAppended = "", vm = this

			let factorVariableValue

			if (factor.variable == 'flat-rate' && "value" in factor)
				factorVariableValue = +factor.value
			else
				factorVariableValue = vm.getAdditionalFactorVariableValue(factor.variable,factor.variableScope,vm.$store.projectBidObjects,componentId)

			let runningProduct = factorVariableValue

			if ("operands" in factor && factor.operands) {
				factor.operands.forEach(op => {
					if (op.operator == 'multiply') {
						operandsAppended += " X "
						runningProduct *= op.value
					}
					else if (op.operator == 'divide') {
						operandsAppended += " / "
						runningProduct /= op.value
					}

					operandsAppended += op.value + " " + op.label + " "
				})
			}

			let variableLabel = ""
			let opt = vm.variableOptions.find(opt => opt.value == factor.variable)
			if (opt) 
				variableLabel = opt.text

			let option = vm.additionalFactorVariableScopeOptions.find(opt => opt.value == factor.variableScope)

			let scope = ""
			if (option)
				scope = option.text

			if (factor.variable == 'flat-rate') {
				factor.variableFormatted = variableLabel
			}
			else
				factor.variableFormatted = factorVariableValue.round(2) + " " + variableLabel + " (" + scope + ")"

			factor.operandsAppended = operandsAppended
			factor.runningProduct = runningProduct
			factor.totalRaw = runningProduct

			factor.totalFormatted = runningProduct.toCurrency()

			return factor
		},
		calcAdditionalFactorValue(factor,bidObjects,componentId) {
			let factorVariableValue = this.getAdditionalFactorVariableValue(factor.variable,factor.variableScope,bidObjects,componentId)
			let runningProduct = factorVariableValue

			factor.operands.forEach(op => {
				if (op.operator == 'multiply') 
					runningProduct *= op.value
				
				else if (op.operator == 'divide') 
					runningProduct /= op.value
			})

			return runningProduct
		},
		calcObjectValue(obj) {
			let markup = +obj.markup
			let priceAdjustment = +obj.price_adjustment
			let qty = +obj.qty

			let rate = +obj.rate

			if (rate == 0 && "field_values_json" in obj) {
				let parsedFields = {}
				try {
					parsedFields = JSON.parse(obj.field_values_json)
				}
				catch (e) {}

				let per = 1
				if ("per" in parsedFields)
					per = +parsedFields.per

				if ('material_price' in parsedFields) 
					rate = +parsedFields.material_price / per
			}

			let total = rate * qty * markup * priceAdjustment

			return total
		},
		//calculates just direct elements, not children
		calcComponentTotal(comp) {
			let vm = this

			let totalValue = 0

			if (comp && "JobBidComponentObject" in comp && comp.JobBidComponentObject) {

				let objects = comp.JobBidComponentObject.filter(obj => obj.bid_component_id == comp.id)

				let runningtotalValue = objects
					.filter(obj => obj.type != 'AdditionalFactor')
					.reduce((acc,obj) => acc + vm.calcObjectValue(obj),0)

				let additionalFactorValue = objects
					.filter(obj => obj.type == "AdditionalFactor")
					.reduce((acc,obj) => {
						try {
							let factor = JSON.parse(obj.field_values_json)
							let value = 0

							if (factor.variable == 'flat-rate')
								value = +factor.value
							else
								value = vm.calcAdditionalFactorValue(factor,vm.$store.projectBidObjects,comp.id)

							return acc + value
						}
						catch (e) {
							return acc
						}
					},0)

				totalValue = runningtotalValue + additionalFactorValue
			}

			return totalValue
		},
		renderJobTaskPayloadFromBid(nestedBid) {
			let records = []
			let sort_order = 0
			let job_id = this.$store.project.id

			if (nestedBid) {
				nestedBid.forEach(bidCat => {

					if ("JobBidComponent" in bidCat && bidCat.JobBidComponent) {
						bidCat.JobBidComponent.forEach(comp => {
							sort_order++ 

							let description = ""
							if (comp.name)
								description = comp.name

							records.push({
								job_id,
								item_number: comp.item_number,
								description,
								unit_value: comp.unitPriceRaw,
								qty: comp.qty,
								sort_order, //organize by category
							})
						})
					}
				})
			}
			return records
		},
		fetchComponentDescendantIds(componentId) {
			let vm = this
			this.getJSON("JobBidComponent/get-component-list",{parent_component_id: this.component.id}).then(response => {
				if (response.success)
					vm.componentDescendantIds = response.data
			})
		},
		fetchBid(bidSlug) {
			let vm = this

			let params = {
				include: [
					{
						model: "JobBidComponent",
						include: ["JobBidComponentObject"],
						filters: [
							["bid_component_id",0]
						],
					},
					"Job"
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("JobBid/find/"+bidSlug,params).then(response => {
					if (response.success) {
						vm.bid = response.data
						vm.fetchBidObjects(response.data.id).then(objectsResponse => {
							resolve(response)
						})
						//this.getJSON("JobBid/get-whole-bid",{bid_id: vm.bid.id})
					}
				})
			})
		},
		fetchActiveBid(options) {
			let params = {
				include: ["JobBidComponent"]
			}

			let endpoint, vm = this

			if ("bidId" in options) {
				endpoint = "JobBid/find/"+options.bidId
			}
			else if ("projectId" in options) {
				endpoint = "JobBid/get"
				params.filters = [
					["is_active",1],
					["job_id",options.projectId]
				]
				params.limit = 1
			}

			return new Promise((resolve,reject) => {
				vm.getJSON(endpoint,params).then(response => {

					if (response.success) {

						if (endpoint == "JobBid/get") {

							if (response.data.length > 0) 
								resolve(response.data[0])
							
							else
								resolve(false)
						}
						else {
							resolve(response.data) 
						}
					}
					else
						resolve(false)
				})
			})
		},
		fetchAllComponents(bidId,include) {
			let vm = this

			let params = {
				filters: [
					["bid_id",bidId]
				]
			}

			if (include) 
				params.include = include
			else {
				params.include = [
					"JobBidComponentObject"
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("JobBidComponent/get",params).then(response => {
					if (response.success)
						vm.$store.bidComponentsFlat = response.data

					resolve(response)
				})

			})
		},
		fetchBidObjects(bid_id) {
			let vm = this

			let params = {
				filters: [
					["bid_id",bid_id]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("JobBidComponent/get",params).then(response => {
					if (response.success) {

						let promises = [], bidComponentIds = []

						response.data.forEach(comp => {
							bidComponentIds.push(comp.id)
							promises.push(vm.getJSON("JobBidComponent/get-component-list",{parent_component_id: comp.id}))
						})

						Promise.all(promises).then(responses => {
							responses.forEach(response => {
								if (response.success) {
									bidComponentIds = [
										...bidComponentIds,
										...response.data
									]
								}
							})

							bidComponentIds = [...new Set(bidComponentIds)]

							params = {
								filters: [
									["bid_component_id",bidComponentIds]
								]
							}

							vm.getJSON("JobBidComponentObject/get",params).then(objResponse => {
								if (objResponse.success) {
									vm.$store.projectBidObjects = objResponse.data.map(obj => { //append bid component relation to object
										obj.JobBidComponent = response.data.find(bidComponent => bidComponent.id == obj.bid_component_id)
									
										return obj
									})

									resolve(objResponse.data)
								}
								resolve([])
							})
						})
						
					}
					else
						resolve([])
				})

			})
		}
	}
}